import React, { Component } from 'react';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { URL, getAuthorizationHeader } from '../../constans/constants';

const getEmpresaId = () => new Cookies().get('empresa');

class BusquedaLegajo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTerm: '',
            searchResults: [],
            isLoading: false,
            showDropdown: false,
            searchTimeout: null,
        };
        this.searchInputRef = React.createRef();
    }

    performSearch = async (searchTerm) => {
        const empresaId = getEmpresaId();
        try {
            this.setState({ isLoading: true });
            const resp = await axios.get(
                `${URL}legajo/listar/${empresaId}?search=${encodeURIComponent(searchTerm)}&size=5`,
                getAuthorizationHeader()
            );
            const legajos = resp.data?.page?.content || [];
            this.setState({ searchResults: legajos, isLoading: false });
        } catch (error) {
            this.setState({ searchResults: [], isLoading: false });
        }
    };

    handleSearchChange = (event) => {
        const value = event.target.value;
        this.setState({ searchTerm: value });

        if (this.state.searchTimeout) clearTimeout(this.state.searchTimeout);

        if (value.length > 0) {
            this.setState({ showDropdown: true, isLoading: true });
            const timeout = setTimeout(() => this.performSearch(value), 300);
            this.setState({ searchTimeout: timeout });
        } else {
            this.setState({ searchResults: [], showDropdown: false, isLoading: false });
            if (this.props.onLegajoChange) this.props.onLegajoChange(null);
        }
    };

    handleSelect = (legajo) => {
        this.setState({
            searchTerm: legajo.nombreApellido,
            searchResults: [],
            showDropdown: false,
        });
        if (this.props.onLegajoChange) this.props.onLegajoChange(legajo);
    };

    handleClear = () => {
        this.setState({ searchTerm: '', searchResults: [], showDropdown: false });
        if (this.props.onLegajoChange) this.props.onLegajoChange(null);
        this.searchInputRef.current?.focus();
    };

    handleClickOutside = (event) => {
        if (!event.target.closest('.search-container')) {
            this.setState({ showDropdown: false });
        }
    };

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
        if (this.state.searchTimeout) clearTimeout(this.state.searchTimeout);
    }

    render() {
        const { searchTerm, searchResults, isLoading, showDropdown } = this.state;

        return (
            <div className="form-group">
                <div className={`ci-search ${showDropdown ? 'searching' : ''} ${searchTerm ? 'has-value' : ''}`}>
                    <input
                        ref={this.searchInputRef}
                        type="text"
                        value={searchTerm}
                        onChange={this.handleSearchChange}
                        placeholder="Buscar colaborador por nombre"
                        className="ci-search__input"
                    />
                    <span className={`material-symbols-outlined ci-search__search-icon ${searchTerm ? 'opacity-0' : 'opacity-100'}`}>
                        search
                    </span>
                    <span
                        className={`material-symbols-outlined ci-search__clear ${searchTerm ? 'opacity-100' : 'opacity-0'} cursor-pointer`}
                        onClick={this.handleClear}
                    >
                        close
                    </span>

                    <div className="ci-search__dropdown">
                        {isLoading ? (
                            <div className="ci-search__no-results">Buscando...</div>
                        ) : searchResults.length > 0 ? (
                            searchResults.map((legajo) => (
                                <div
                                    key={legajo.legajoId}
                                    onClick={() => this.handleSelect(legajo)}
                                    className="ci-search__option"
                                >
                                    <div className="ci-search__option-content">
                                        <div className="ci-search__option-name">{legajo.nombreApellido}</div>
                                        <div className="ci-search__option-ci">C.I.: {legajo.cedula}</div>
                                        <div className="ci-search__option-username">Usuario: {legajo.username}</div>
                                    </div>
                                </div>
                            ))
                        ) : searchTerm.length > 0 ? (
                            <div className="ci-search__no-results">No se encontraron colaboradores</div>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

export default BusquedaLegajo;
